'use client';

import { useQuery } from '@tanstack/react-query';
import { getMainCatsClient } from '@util/firestore/categories';
import { CategoryDocument } from 'models/category';
import { useCreateListing } from '../_context';
import { ListingCard } from './ListingCard';
import { useRouter } from 'next/navigation';

const haveSubCategories = (catId: string | undefined) => {
  return (
    catId === 'categories_new/race-cars-for-sale' ||
    catId === 'categories_new/parts'
  );
};

export const CreateListingStepTwo = () => {
  const router = useRouter();

  const { form, setCurrentStep, setCategoryInfo, categoryInfo } =
    useCreateListing();

  const { data: mainCategories, isLoading } = useQuery({
    queryKey: ['mainCategories'],
    queryFn: () => getMainCatsClient(true),
  });

  const errors = form.formState.errors.ride_types?.message;

  const goBack = () => router.push('/');

  const categoryOnClick = (c: CategoryDocument) => {
    setCategoryInfo([c]);

    if (c.name === "Other") {
      form.setValue('category', "Other");
      setCurrentStep((prev) => prev + 3);
      return
    }

    if (!haveSubCategories(c?.id)) {
      setCurrentStep((prev) => prev + 2);
      return;
    }

    setCurrentStep((prev) => prev + 1);
  };

  return (
    <div className="flex w-full flex-col justify-between px-8 pt-12 sm:mx-auto sm:max-w-[100rem] sm:py-32 md:pt-20">
      <h1 className="mb-12 text-heading-h5 font-bold text-black md:mb-20 md:text-heading-h4">
        Select a category
      </h1>
      <div className="mb-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:mb-20 lg:grid-cols-4">
        {isLoading
          ? Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className="h-[220px] w-[165px] animate-pulse rounded bg-gray-200 md:h-[260px] md:w-[189px]"
            />
          ))
          : mainCategories?.map((category, i) => (
            <ListingCard
              key={i}
              category={category}
              onClick={categoryOnClick}
              selectedCategory={categoryInfo[0]}
            />
          ))}
      </div>
      <div className="flex w-full flex-col items-center gap-[1rem] py-8 md:py-12">
        {errors && <p className="text-[1.5rem] text-brand-red">{errors}</p>}
        <div className="flex w-full">
          <button
            className="h-[44px] w-full rounded-full border border-black text-center text-[1.875rem] font-semibold md:w-[184px]"
            type="button"
            onClick={goBack}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};
